import React from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import Breadcrumb from '@prisjakt/ui-breadcrumb';
import CampaignBreadcrumb from '../campaign/components/breadcrumb';
import PageContent from '../../components/page-content';
import FeaturedArticle from '../../components/featured-article';
import * as S from './styles';

class ArticlePage extends React.PureComponent {
  renderBreadcrumb() {
    const { article } = this.props.data;
    const { campaign, category } = article.related;

    if (campaign) {
      return <CampaignBreadcrumb campaign={campaign} article={article} />;
    }
    return (
      <Breadcrumb
        homeText={this.context.t('common', 'breadcrumb.home')}
        path={(category ? category.path : []).concat([
          {
            id: `article:${article.id}`,
            path: article.pathName,
            name: article.title,
          },
        ])}
      />
    );
  }

  render() {
    const { article } = this.props.data;
    const { renderMode } = this.context;
    const legacyMode = ['mobile', 'desktop'].includes(renderMode);

    return (
      <PageContent withAds>
        <S.Article legacyMode={legacyMode}>
          {this.renderBreadcrumb()}
          <S.Wrapper>
            <FeaturedArticle article={article} embedded={false} />
          </S.Wrapper>
        </S.Article>
      </PageContent>
    );
  }
}

const { shape, arrayOf, number, string, oneOfType, object } = PropTypes;

const ArticleType = shape({
  id: oneOfType([number, string]),
  title: string,
  preamble: string,
  body: string,
  byline: string,
  imageUrl: string,
  imageCaption: string,
  metaTitle: string,
  metaDescription: string,
  pathName: string,
  related: shape({
    campaign: object,
    category: object,
    articles: arrayOf(object),
  }),
});

ArticlePage.propTypes = {
  data: shape({
    article: ArticleType,
  }).isRequired,
};

ArticlePage.contextType = AppContext;

export default ArticlePage;
